// actions.js
import {
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  DELETE_PROJECTS_REQUEST,
  DELETE_PROJECTS_FAILURE,
  DELETE_PROJECTS_SUCCESS,
  FETCH_PROJECT_REQUEST,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  UPDATE_PROJECTS_REQUEST,
  UPDATE_PROJECTS_SUCCESS,
  UPDATE_PROJECTS_FAILURE,
  CLEAR_PROJECT_ERRORS,
  CLEAR_PROJECT_SUCCESS,
} from './actionTypes';

export const fetchProjectsRequest = () => ({
  type: FETCH_PROJECTS_REQUEST,
});

export const fetchProjectsSuccess = (projects) => ({
  type: FETCH_PROJECTS_SUCCESS,
  payload: projects,
});

export const fetchProjectsFailure = (error) => ({
  type: FETCH_PROJECTS_FAILURE,
  payload: error,
});

export const fetchProjectRequest = (id) => ({
  type: FETCH_PROJECT_REQUEST,
  payload: id
});

export const fetchProjectSuccess = (project) => ({
  type: FETCH_PROJECT_SUCCESS,
  payload: project,
});

export const fetchProjectFailure = (error) => ({
  type: FETCH_PROJECT_FAILURE,
  payload: error,
});

export const updateProjectRequest = (project, navigate) => ({
  type: UPDATE_PROJECTS_REQUEST,
  payload: { project, navigate }
});

export const updateProjectSuccess = () => ({
  type: UPDATE_PROJECTS_SUCCESS,
});

export const updateProjectFailure = (error) => ({
  type: UPDATE_PROJECTS_FAILURE,
  payload: error,
});

export const deleteProjectRequest = (id) => ({
  type: DELETE_PROJECTS_REQUEST,
  payload: id
});

export const deleteProjectSuccess = (id) => ({
  type: DELETE_PROJECTS_SUCCESS,
  payload: id,
});

export const deleteProjectFailure = (error) => ({
  type: DELETE_PROJECTS_FAILURE,
  payload: error,
});

export const clearProjectErrors = () => ({
  type: CLEAR_PROJECT_ERRORS,
});

export const clearProjectSuccess = () => ({
  type: CLEAR_PROJECT_SUCCESS,
});
